/* variants.js (full replacement)
   - Fixes missing braces / method boundaries
   - Adds safe guards so variant logic doesn’t crash when elements are missing
   - Keeps your existing behaviour (media switching, sticky cart, subtotal, swatches, etc.)
*/

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.item = $(this).closest('.productView');
    this.isFullWidth =
      this.item.closest('.product-full-width').length == 1 ||
      this.item.closest('.product-full-width-2').length == 1;

    this.onVariantInit();
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantInit() {
    this.updateOptions();
    this.updateMasterId();
    this.updateMedia(1500, 'init');
    // this.updateURL();
    this.renderProductAjaxInfo();
    this.renderProductInfo();

    if (!this.currentVariant) {
      this.updateAttribute(true);
    } else {
      this.updateAttribute(false, !this.currentVariant.available);
    }

    this.updateVariantStatuses();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.updateAttribute(true);
      this.updateStickyAddToCart(true);
    } else {
      this.updateMedia(200, 'change');
      if (!document.querySelector('.featured-product')) {
        this.updateURL();
      }
      this.updateVariantInput();
      this.renderProductAjaxInfo();
      this.renderProductInfo();
      this.updateProductInfo();
      this.updateAttribute(false, !this.currentVariant.available);
      this.updateStickyAddToCart(false, !this.currentVariant.available);
      this.checkQuantityWhenVariantChange();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  decodeOptions() {
    this.options = (this.options || []).map((option) => this.decodeOption(option));
  }

  decodeOption(option) {
    if (!option) return null;
    return option
      .split('Special_Double_Quote')
      .join('"')
      .split('Special_Slash')
      .join('/');
  }

  encodeOption(option) {
    if (!option) return null;
    return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash');
  }

  updateMasterId() {
    this.decodeOptions();

    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => this.options[index] === option)
        .includes(false);
    });

    if (
      this.item.find('[data-filter]').length &&
      this.currentVariant?.featured_media &&
      this.currentVariant.featured_media.alt != null
    ) {
      this.item
        .find('[data-filter]:checked')
        .attr(
          'data-value-default-lang',
          this.currentVariant.featured_media.alt.toLowerCase().replace(/ /g, '-')
        );
    }
  }

  updateMedia(time, status) {
    const enableVariantImageGroup = document?.querySelector('.enable_variant_image_group');
    if (enableVariantImageGroup && status == 'init') return;

    setTimeout(() => {
      if (
        !this.currentVariant ||
        !this.currentVariant?.featured_media ||
        document.querySelector('.productView-nav')?.matches('.media-filter')
      )
        return;

      const newMedia = document.querySelectorAll(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
      );

      if (!newMedia || !newMedia.length) return;

      window.setTimeout(() => {
        $(newMedia).trigger('click');
      }, time);

      if (!this.isFullWidth || window.innerWidth < 768 || !this.currentVariant) return;

      const mediaId = this.currentVariant.featured_media.id;
      const mediaToReplace = document?.querySelector('.productView-image[data-index="1"]');

      if (mediaId) {
        const mediaEl = document?.querySelector(`.product-single__media[data-media-id="${mediaId}"]`);
        const activeThumbnail = mediaEl?.parentElement;
        if (!activeThumbnail?.parentElement) return;

        activeThumbnail.parentElement.prepend(activeThumbnail);
        setTimeout(() => {
          if (mediaToReplace) this.scrollToBlock(mediaToReplace);
        }, 20);
      } else {
        const imageToReplace = mediaToReplace?.querySelector('img');
        const image = this.currentVariant?.featured_image;
        if (!image || !imageToReplace) return;

        imageToReplace.setAttribute('src', image.src);
        imageToReplace.setAttribute('srcset', image.src);
        imageToReplace.setAttribute('alt', image.alt);

        if (mediaToReplace?.getBoundingClientRect().top < window.scrollY && mediaToReplace) {
          this.scrollToBlock(mediaToReplace);
        }
      }
    }, 1);
  }

  scrollToBlock(block) {
    const headerHeight =
      document.querySelectorAll('.section-header-navigation')[0]?.getBoundingClientRect().height || 0;
    const announcementBarHeight =
      document.querySelectorAll('.announcement-bar')[0]?.getBoundingClientRect().height || 0;
    const positionTop = block.getBoundingClientRect().top - headerHeight - announcementBarHeight;

    window.scrollTo({
      top: positionTop,
      behavior: 'smooth',
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductAjaxInfo() {
    if (!this.currentVariant?.id) return;

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `product-price-${this.dataset.product}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        const property = `product-property-${this.dataset.product}`;
        const destinationProperty = document.getElementById(property);
        const sourceProperty = html.getElementById(property);

        if (source && destination) destination.innerHTML = source.innerHTML;

        if (this.checkNeedToConvertCurrency()) {
          const currencyCode = document
            .getElementById('currencies')
            ?.querySelector('.active')
            ?.getAttribute('data-currency');

          if (currencyCode && typeof Currency !== 'undefined') {
            Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
          }
        }

        if (destinationProperty) {
          if (sourceProperty) {
            destinationProperty.innerHTML = sourceProperty.innerHTML;
            destinationProperty.style.display = 'table';
          } else {
            destinationProperty.style.display = 'none';
          }
        } else if (sourceProperty) {
          document
            .querySelector('.productView-product')
            ?.insertBefore(sourceProperty, document.querySelector('.productView-options'));
        }

        document.getElementById(id)?.classList.remove('visibility-hidden');
        if (this.currentVariant) this.updateBadgeSale();
      })
      .catch(() => {});
  }

  renderProductInfo() {
    if (!this.currentVariant) return;

    if (this.item.find('[data-sku]').length > 0) {
      this.item.find('[data-sku] .productView-info-value').text(this.currentVariant.sku);
    }

    if (this.item.find('[data-barcode]').length > 0) {
      this.item.find('[data-barcode] .productView-info-value').text(this.currentVariant.barcode);
    }

    const inventory = this.currentVariant?.inventory_management;

    if (inventory != null) {
      const arrayInVarName = `product_inven_array_${this.dataset.product}`;
      const inven_array = window[arrayInVarName];

      if (inven_array != undefined) {
        const inven_num = inven_array[this.currentVariant.id];
        const inputQuantity = this.item.find('input[name="quantity"]');
        const buttonSubmit = this.item.find('button#product-add-to-cart');
        const inventoryQuantity = parseInt(inven_num);

        if (inputQuantity.length > 0) inputQuantity.attr('data-inventory-quantity', inventoryQuantity);
        else buttonSubmit.attr('data-inventory-quantity', inventoryQuantity);

        if (this.item.find('[data-inventory]').length > 0) {
          if (inventoryQuantity > 0) {
            const showStock = this.item.find('[data-inventory]').data('stock-level');
            if (showStock == 'show') {
              this.item
                .find('[data-inventory] .productView-info-value')
                .text(inventoryQuantity + ' ' + window.inventory_text.inStock);
            } else {
              this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.inStock);
            }
          } else {
            this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.outOfStock);
          }
        }

        hotStock(inventoryQuantity);
      }
    }

    if (this.item.find('.productView-stickyCart').length > 0) {
      const sticky = this.item.find('.productView-stickyCart');
      const optionSticky = sticky.find('.select__select');
      optionSticky.val(this.currentVariant.id);
    }
  }

  updateProductInfo() {
    if (!this.currentVariant?.id) return;

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const selector = `[data-product-description-${this.dataset.product}]`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destinationDesc = document.querySelector(selector);
        const sourceDesc = html.querySelector(selector);

        if (sourceDesc && destinationDesc) {
          destinationDesc.innerHTML = sourceDesc.innerHTML;
          if (destinationDesc.closest('.toggle-content--height')) destinationDesc.style.maxHeight = null;
        }
      })
      .catch(() => {});
  }

  updateAttribute(unavailable = true, disable = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.product}`)
      ?.querySelector('[name="add"]');

    const quantityInput = this.item.find('input[name="quantity"]');
    const notifyMe = this.item.find('.productView-notifyMe');
    const hotStockEl = this.item.find('.productView-hotStock');
    const buttonAddtocart = this.item.find('.product-form__submit');

    let maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
    if (isNaN(maxValue)) maxValue = parseInt(buttonAddtocart.attr('data-inventory-quantity'));
    else maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));

    if (unavailable) {
      const text = window.variantStrings.unavailable;

      quantityInput.attr('disabled', true);
      notifyMe.slideUp('slow');
      if (addButton != null) {
        addButton.setAttribute('disabled', true);
        addButton.textContent = text;
      }
      quantityInput.closest('quantity-input').addClass('disabled');

      if (hotStockEl.length > 0) hotStockEl.addClass('is-hiden');
      return;
    }

    // --- Available path
    if (disable) {
      let text = window.variantStrings.soldOut;
      let subTotal = 0;
      const price = this.currentVariant?.price;

      const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
      const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

      if (window.subtotal.show) {
        const qty = quantityInput.val() || 1;
        subTotal = qty * price;
        subTotal = Shopify.formatMoney(subTotal, window.money_format);
        subTotal = extractContent(subTotal);

        const moneySpan = document.createElement('span');
        moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal');
        moneySpan.innerText = subTotal;
        document.body.appendChild(moneySpan);

        if (this.checkNeedToConvertCurrency()) {
          const currencyCode = document
            .getElementById('currencies')
            ?.querySelector('.active')
            ?.getAttribute('data-currency');
          if (currencyCode && typeof Currency !== 'undefined') {
            Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
          }
        }

        subTotal = moneySpan.innerText;
        $(moneySpan).remove();

        if (window.subtotal.style == '1') {
          const pdView_subTotal =
            document.querySelector('.productView-subtotal .money') ||
            document.querySelector('.productView-subtotal .money-subtotal');
          if (pdView_subTotal != null) pdView_subTotal.textContent = subTotal;
        } else if (window.subtotal.style == '2') {
          text = window.subtotal.text.replace('[value]', subTotal);
        }
      } else {
        subTotal = Shopify.formatMoney(price, window.money_format);
        subTotal = extractContent(subTotal);
      }

      quantityInput.attr('data-price', this.currentVariant?.price);
      quantityInput.attr('disabled', true);
      if (addButton != null) {
        addButton.setAttribute('disabled', true);
        addButton.textContent = text;
      }
      quantityInput.closest('quantity-input').addClass('disabled');

      if (subTotal != 0 && stickyPrice.length) stickyPrice.text(subTotal);

      const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
      const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
      const compare_at_price = this.currentVariant?.compare_at_price;
      const current_at_price = this.currentVariant?.price;

      if (compare_at_price == current_at_price) {
        thisStickyPrice.removeClass('has-compare-price');
        thisComparePrice.remove();
      } else {
        if (compare_at_price) {
          thisStickyPrice.addClass('has-compare-price');
          if (thisComparePrice.length) {
            thisComparePrice.attr('data-compare-price', compare_at_price);
          } else {
            thisStickyPrice.prepend(
              `<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`
            );
          }
        } else {
          thisStickyPrice.removeClass('has-compare-price');
          thisComparePrice.remove();
        }
      }

      if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
        let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price');
        const qty = quantityInput.val() || 1;
        comparePrice = qty * comparePrice;
        comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
        comparePrice = extractContent(comparePrice);
        stickyComparePrice.text(comparePrice);
      }

      if (notifyMe.length > 0) {
        notifyMe.find('.halo-notify-product-variant').val(this.currentVariant.title);
        notifyMe.find('.notifyMe-text').empty();
        notifyMe.slideDown('slow');
      }
    } else {
      let text;
      let subTotal = 0;
      const price = this.currentVariant?.price;

      const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');

      if (window.subtotal.show) {
        const qty = quantityInput.val() || 1;
        subTotal = qty * price;
        subTotal = Shopify.formatMoney(subTotal, window.money_format);
        subTotal = extractContent(subTotal);

        const moneySpan = document.createElement('span');
        moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal');
        moneySpan.innerText = subTotal;
        document.body.appendChild(moneySpan);

        if (this.checkNeedToConvertCurrency()) {
          const currencyCode = document
            .getElementById('currencies')
            ?.querySelector('.active')
            ?.getAttribute('data-currency');
          if (currencyCode && typeof Currency !== 'undefined') {
            Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
          }
        }

        subTotal = moneySpan.innerText;
        $(moneySpan).remove();

        if (window.subtotal.style == '1') {
          const pdView_subTotal =
            document.querySelector('.productView-subtotal .money') ||
            document.querySelector('.productView-subtotal .money-subtotal');

          if (pdView_subTotal != null) pdView_subTotal.textContent = subTotal;

          if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == 'shopify') {
            text = window.variantStrings.preOrder;
          } else {
            text = window.variantStrings.addToCart;
          }
        } else if (window.subtotal.style == '2') {
          if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == 'shopify') {
            text = window.variantStrings.preOrder;
          } else {
            text = window.subtotal.text.replace('[value]', subTotal);
            $('#show-sticky-product').text(text);
            $('#product-sticky-add-to-cart').text(text);
          }
        }
      } else {
        subTotal = Shopify.formatMoney(price, window.money_format);
        subTotal = extractContent(subTotal);
        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == 'shopify') {
          text = window.variantStrings.preOrder;
        } else {
          text = window.variantStrings.addToCart;
        }
      }

      quantityInput.attr('data-price', this.currentVariant?.price);
      quantityInput.attr('disabled', false);
      if (addButton != null) {
        addButton.removeAttribute('disabled');
        addButton.textContent = text;
      }
      quantityInput.closest('quantity-input').removeClass('disabled');

      if (subTotal != 0 && stickyPrice.length) stickyPrice.text(subTotal);

      const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
      const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
      const compare_at_price = this.currentVariant?.compare_at_price;
      const current_at_price = this.currentVariant?.price;

      if (compare_at_price == current_at_price) {
        thisStickyPrice.removeClass('has-compare-price');
        thisComparePrice.remove();
      } else {
        if (compare_at_price) {
          thisStickyPrice.addClass('has-compare-price');
          if (thisComparePrice.length) {
            thisComparePrice.attr('data-compare-price', compare_at_price);

            const compare_at_price_sticky = Shopify.formatMoney(compare_at_price, window.money_format);
            const comparePrice_sticky = extractContent(compare_at_price_sticky);
            thisComparePrice.text(comparePrice_sticky);

            if (this.checkNeedToConvertCurrency()) {
              const currencyCode = document
                .getElementById('currencies')
                ?.querySelector('.active')
                ?.getAttribute('data-currency');
              if (currencyCode && typeof Currency !== 'undefined') {
                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
              }
            }

            thisStickyPrice.prepend(
              `<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`
            );
            thisComparePrice.remove();
          } else {
            thisStickyPrice.prepend(
              `<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`
            );
          }
        } else {
          thisStickyPrice.removeClass('has-compare-price');
          thisComparePrice.remove();
        }
      }

      const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');
      if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
        let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price');
        const qty = quantityInput.val() || 1;
        comparePrice = qty * comparePrice;
        comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
        comparePrice = extractContent(comparePrice);
        stickyComparePrice.text(comparePrice);
      }

      if (notifyMe.length > 0) notifyMe.slideUp('slow');
    }
  }

  updateStickyAddToCart(unavailable = true, disable = true) {
    if (this.item.find('.productView-stickyCart').length <= 0) return;

    const sticky = this.item.find('.productView-stickyCart');
    const itemImage = sticky.find('.sticky-image');
    const option = sticky.find('.select__select');
    const input = document
      .getElementById(`product-form-sticky-${this.dataset.product}`)
      ?.querySelector('input[name="id"]');
    const button = document
      .getElementById(`product-form-sticky-${this.dataset.product}`)
      ?.querySelector('[name="add"]');

    const quantityInput = this.item.find('input[name="quantity"]');
    const submitBtn = $('.product-form__submit');

    let maxValue;
    if (quantityInput.length > 0) maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
    else maxValue = parseInt(submitBtn.attr('data-inventory-quantity'));

    if (!button) return;

    if (unavailable) {
      const text = window.variantStrings.unavailable;
      button.setAttribute('disabled', true);
      button.textContent = text;
      return;
    }

    if (!this.currentVariant) return;

    const image = this.currentVariant?.featured_image;
    if (image != null) {
      itemImage.find('img').attr({
        src: image.src,
        srcset: image.src,
        alt: image.alt,
      });
    }

    option.val(this.currentVariant.id);

    if (disable) {
      const text = window.variantStrings.soldOut;
      button.setAttribute('disabled', true);
      button.textContent = text;
    } else {
      let text;
      if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == 'shopify') {
        text = window.variantStrings.preOrder;
      } else {
        text = window.variantStrings.addToCart;
      }
      button.removeAttribute('disabled');
      button.textContent = text;
    }

    if (input) {
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]')?.textContent || '[]');
    return this.variantData;
  }

  checkNeedToConvertCurrency() {
    const currencyItem = $('.dropdown-item[data-currency]');
    if (!currencyItem.length) return false;
    return (
      (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency
    );
  }

  checkQuantityWhenVariantChange() {
    const quantityInput = this.closest('.productView-details')?.querySelector('input.quantity__input');
    const maxValue = parseInt(quantityInput?.dataset.inventoryQuantity);
    const inputValue = parseInt(quantityInput?.value);

    let value = inputValue;
    if (inputValue > maxValue && maxValue > 0) value = maxValue;
    if (value < 1 || isNaN(value)) value = 1;
    if (quantityInput) quantityInput.value = value;

    const elementProductAddToCart = document.getElementById('product-add-to-cart');
    if (elementProductAddToCart && this.currentVariant?.available !== undefined && typeof maxValue !== 'undefined') {
      elementProductAddToCart.dataset.available = this.currentVariant.available && maxValue <= 0;
    }
  }

  // ✅ FIXED (proper braces + safe guards)
  updateVariantStatuses() {
    this.getVariantData();
    if (!this.variantData || !this.variantData.length) return;

    const checked = this.querySelector(':checked');
    if (!checked) return;

    const selectedOptionOneVariants = this.variantData.filter((variant) => checked.value === variant.option1);

    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    const inputLength = inputWrappers.length;
    const variant_swatch = [...this.querySelectorAll('.product-form__swatch')];

    inputWrappers.forEach((option, index) => {
      const header = option.querySelector('[data-header-option]');
      const optionChecked = option.querySelector(':checked');

      if (header && optionChecked) header.innerText = optionChecked.value;
      if (!optionChecked) return;

      if (index === 0 && inputLength > 1) return;

      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];

      const prevChecked =
        inputLength > 1 ? inputWrappers[index - 1]?.querySelector(':checked') : optionChecked;

      if (!prevChecked) return;

      const previousOptionSelected = prevChecked.value;

      const optionInputsValue =
        inputLength > 1
          ? selectedOptionOneVariants
              .filter((variant) => variant[`option${index}`] === previousOptionSelected)
              .map((v) => v[`option${index + 1}`])
          : this.variantData.map((v) => v[`option${index + 1}`]);

      const availableOptionInputsValue =
        inputLength > 1
          ? selectedOptionOneVariants
              .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
              .map((v) => v[`option${index + 1}`])
          : this.variantData.filter((variant) => variant.available).map((v) => v[`option${index + 1}`]);

      this.setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue);

      if (variant_swatch.length > 1) {
        this.updateImageSwatch(selectedOptionOneVariants);
      }
    });
  }

  updateImageSwatch(selectedOptionOneVariants) {
    const inputWrappers = this.querySelectorAll('.product-form__input');
    if (!inputWrappers) return;

    inputWrappers.forEach((element, inputIndex) => {
      const imageSpan = element.querySelectorAll('label>span.pattern');
      const imageLabel = element.querySelectorAll('label');
      const imageSpanImage = element.querySelectorAll('label>span.expand>img');
      const inputList = element.querySelectorAll('input');

      inputList.forEach((item, index) => {
        const image = selectedOptionOneVariants.filter((tmp) => {
          if (inputIndex == 0) return tmp.option1 == item.value;
          if (inputIndex == 1) return tmp.option2 == item.value;
          if (inputIndex == 2) return tmp.option3 == item.value;
          return false;
        });

        if (image.length > 0) {
          if (imageLabel[index]) imageLabel[index].style.display = 'inline-block';
          if (imageSpan[index] != undefined && image[0].featured_image != null) {
            imageSpan[index].style.backgroundImage = `url("${image[0].featured_image.src}")`;
          }
          if (imageSpanImage[index] != undefined && image[0].featured_image != null) {
            imageSpanImage[index].srcset = image[0].featured_image.src;
          }
        }
      });
    });
  }

  setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
    optionInputs.forEach((input) => {
      const val = input.getAttribute('value');

      if (availableOptionInputsValue.includes(val)) {
        input.classList.remove('soldout');
        input.innerText = val;
      } else {
        input.classList.add('soldout');
        if (optionInputsValue.includes(val)) {
          input.innerText = `${val} (Sold out)`;
        } else {
          input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', val);
        }
      }
    });
  }

  updateBadgeSale() {
    try {
      const scope = this.item?.length ? this.item[0] : document;

      const badgeWrap = scope.querySelector('.productView-badge');
      if (!badgeWrap) return;

      const badgeTextSaleType = badgeWrap.getAttribute('data-text-sale-badge') || '';

      const compareEl = scope.querySelector('.productView-product .price__compare');
      const lastEl = scope.querySelector('.productView-product .price__sale .price__last');

      if (!compareEl || !lastEl) {
        badgeWrap.querySelector('.badge.sale-badge')?.remove();
        return;
      }

      const priceCompareRaw = compareEl.getAttribute('data-compare');
      const priceLastRaw = lastEl.getAttribute('data-last');

      if (!priceCompareRaw || !priceLastRaw) {
        badgeWrap.querySelector('.badge.sale-badge')?.remove();
        return;
      }

      const priceCompare = Number(priceCompareRaw);
      const priceLast = Number(priceLastRaw);

      if (!Number.isFinite(priceCompare) || !Number.isFinite(priceLast) || priceCompare <= 0) {
        badgeWrap.querySelector('.badge.sale-badge')?.remove();
        return;
      }

      const percentSale = Math.round(((priceCompare - priceLast) / priceCompare) * 100);

      if (!Number.isFinite(percentSale) || percentSale <= 0) {
        badgeWrap.querySelector('.badge.sale-badge')?.remove();
        return;
      }

      let badge = badgeWrap.querySelector('.badge.sale-badge');

      if (!badge) {
        badge = document.createElement('span');
        badge.classList.add('badge', 'sale-badge');
        badgeWrap.appendChild(badge);
      }

      if (badgeWrap.classList.contains('has-badge-js')) {
        badge.textContent = `${badgeTextSaleType} ${percentSale}%`;
      } else {
        badge.textContent = `${badgeTextSaleType}`;
      }
    } catch (e) {
      console.warn('updateBadgeSale() failed safely:', e);
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
    optionInputs.forEach((input) => {
      const val = input.getAttribute('value');

      if (availableOptionInputsValue.includes(val)) {
        input.nextSibling?.classList?.remove('soldout', 'unavailable');
        input.nextSibling?.classList?.add('available');
      } else {
        input.nextSibling?.classList?.remove('available', 'unavailable');
        input.nextSibling?.classList?.add('soldout');

        if (window.variantStrings.hide_variants_unavailable && !optionInputsValue.includes(val)) {
          input.nextSibling?.classList?.add('unavailable');
          if (!input.checked) return;

          let inputsValue;
          inputsValue = availableOptionInputsValue.length > 0 ? availableOptionInputsValue : optionInputsValue;

          const nextToCheck = input.closest('.product-form__input')?.querySelector(`input[value="${inputsValue[0]}"]`);
          if (nextToCheck) nextToCheck.checked = true;

          this.dispatchEvent(new Event('change'));
        }
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    if (this.closest('.quick-order-list__contents')) return;

    this.input = this.querySelector('input');
    if (!this.input) return;

    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );

    if (!this.checkHasMultipleVariants()) {
      this.initProductQuantity();
      this.checkVariantInventory();
    }
  }

  onInputChange(event) {
    event.preventDefault();

    let inputValue = parseInt(this.input.value);
    const maxValue = parseInt(this.input.dataset.inventoryQuantity);
    const currentId = document
      .getElementById(`product-form-${this.input.dataset.product}`)
      ?.querySelector('[name="id"]')
      ?.value;

    const saleOutStock = document.getElementById('product-add-to-cart')?.dataset.available === 'true' || false;
    const addButton = document
      .getElementById(`product-form-${this.input.dataset.product}`)
      ?.querySelector('[name="add"]');

    if (isNaN(inputValue) || inputValue < 1) inputValue = 1;
    this.input.value = inputValue;

    if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
      const arrayInVarName = `selling_array_${this.input.dataset.product}`;
      const itemInArray = window[arrayInVarName];
      const itemStatus = itemInArray?.[currentId];

      if (itemStatus == 'deny') {
        this.input.value = maxValue;
        const message = getInputMessage(maxValue);
        showWarning(message, 3000);
        inputValue = maxValue;
      }
    } else if (inputValue > maxValue && saleOutStock && maxValue <= 0) {
      this.input.value = inputValue;
    }

    if (window.subtotal.show) {
      let text;
      const price = this.input.dataset.price;
      let subTotal = inputValue * price;

      subTotal = Shopify.formatMoney(subTotal, window.money_format);
      subTotal = extractContent(subTotal);

      const moneySpan = document.createElement('span');
      moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal');
      moneySpan.innerText = subTotal;
      document.body.appendChild(moneySpan);

      if (this.checkNeedToConvertCurrency()) {
        const currencyCode = document
          .getElementById('currencies')
          ?.querySelector('.active')
          ?.getAttribute('data-currency');
        if (currencyCode && typeof Currency !== 'undefined') {
          Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
        }
      }

      subTotal = moneySpan.innerText;
      $(moneySpan).remove();

      if (window.subtotal.style == '1') {
        const pdView_subTotal =
          document.querySelector('.productView-subtotal .money') ||
          document.querySelector('.productView-subtotal .money-subtotal');

        if (pdView_subTotal) pdView_subTotal.textContent = subTotal;
      } else if (window.subtotal.style == '2') {
        text = window.subtotal.text.replace('[value]', subTotal);
        $('#product-sticky-add-to-cart').text(text);
        if (addButton != null) addButton.textContent = text;
      }

      const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
      const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

      if (stickyPrice.length) stickyPrice.text(subTotal);

      if (stickyComparePrice.length && window.subtotal.show) {
        let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price');
        comparePrice = inputValue * comparePrice;
        comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
        comparePrice = extractContent(comparePrice);
        stickyComparePrice.text(comparePrice);
      }
    }

    // Sync grouped quantities
    if (this.classList.contains('quantity__group--2') || this.classList.contains('quantity__group--3')) {
      const mainQty = document.querySelector('.quantity__group--1 .quantity__input');
      if (mainQty != null) mainQty.value = inputValue;

      const mainQty2Exists = !!document.querySelector('.quantity__group--2 .quantity__input');
      const mainQty3Exists = !!document.querySelector('.quantity__group--3 .quantity__input');

      if (this.classList.contains('quantity__group--2') && mainQty3Exists) {
        const mainQty3 = document.querySelector('.quantity__group--3 .quantity__input');
        if (mainQty3) mainQty3.value = inputValue;
      } else if (this.classList.contains('quantity__group--3') && mainQty2Exists) {
        const mainQty2 = document.querySelector('.quantity__group--2 .quantity__input');
        if (mainQty2) mainQty2.value = inputValue;
      }
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency
    );
  }

  checkHasMultipleVariants() {
    const productId = this.querySelector('[data-product]')?.dataset?.product;
    if (!productId) return true;
    const arrayInVarName = `product_inven_array_${productId}`;
    this.inven_array = window[arrayInVarName];
    if (!this.inven_array) return true;
    return Object.keys(this.inven_array).length > 1;
  }

  initProductQuantity() {
    if (this.inven_array != undefined) {
      const inven_num = Object.values(this.inven_array);
      const inventoryQuantity = parseInt(inven_num);

      this.querySelector('input[name="quantity"]')?.setAttribute('data-inventory-quantity', inventoryQuantity);
      const q = this.querySelector('input[name="quantity"]');
      if (q) q.dataset.inventoryQuantity = inventoryQuantity;
    }
  }

  checkVariantInventory() {
    const addBtn = document.getElementById('product-add-to-cart');
    if (!addBtn) return;

    this.input.disabled = addBtn.disabled;
    this.querySelector('.btn-quantity.minus') && (this.querySelector('.btn-quantity.minus').disabled = addBtn.disabled);
    this.querySelector('.btn-quantity.plus') && (this.querySelector('.btn-quantity.plus').disabled = addBtn.disabled);
  }
}

customElements.define('quantity-input', QuantityInput);

// ---- Helpers (unchanged behaviour)
function hotStock(inventoryQuantity) {
  const productView = document.querySelector('.productView');
  if (!productView) return;

  const hotStockEl = productView.querySelector('.productView-hotStock');
  if (!hotStockEl) return;

  const hotStockText = hotStockEl.querySelector('.hotStock-text');
  const maxStock = parseFloat(hotStockEl.dataset.hotStock);
  let textStock;

  if (inventoryQuantity > 0 && inventoryQuantity <= maxStock) {
    textStock = hotStockEl.matches('.style-2')
      ? window.inventory_text.hotStock2.replace('[inventory]', inventoryQuantity)
      : window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);

    if (hotStockText) hotStockText.innerHTML = textStock;
    hotStockEl.classList.remove('is-hide');
  } else {
    hotStockEl.classList.add('is-hide');
  }

  if (hotStockEl.matches('.style-2')) {
    const invenProgress = (inventoryQuantity / maxStock) * 100;
    const hotStockProgressItem = hotStockEl.querySelector('.hotStock-progress-item');
    if (hotStockProgressItem) hotStockProgressItem.style.width = `${invenProgress}%`;
  }
}

const hotStockNoOptions = document.querySelector('.productView .productView-hotStock[data-current-inventory]');
if (hotStockNoOptions) {
  const inventoryQuantity = parseFloat(hotStockNoOptions.dataset.currentInventory);
  hotStock(inventoryQuantity);
}

function showWarning(content, time = null) {
  if (window.warningTimeout) clearTimeout(window.warningTimeout);

  const popup = document.getElementById('halo-warning-popup');
  const warningPopupContent = popup?.querySelector('[data-halo-warning-content]');
  if (warningPopupContent) warningPopupContent.textContent = content;

  document.body.classList.add('has-warning');

  if (time) {
    window.warningTimeout = setTimeout(() => {
      document.body.classList.remove('has-warning');
    }, time);
  }
}

function getInputMessage(maxValue) {
  return window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
}